export default __webpack_public_path__ + "static/media/empty.d5f805e4.png";